import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'

import TableTbody from './table-tbody'
import SearchBox from './searchBox'
import { usersAction } from '../../redux/action/users'
import { CircleLoading } from '../../components/loading/circleloading'

class userManagePage extends Component {
  state = {
    searchfield: '',
  }
  componentDidMount() {
    this.props.loadUsers()
  }
  onSearchChange = (event) => {
    this.setState({ searchfield: event.target.value })
  }
  render() {

    const { searchfield } = this.state
    const { users } = this.props
    const filterUser = users.data && (users.data).filter((user) => {
      return user.username.toLowerCase().includes(searchfield.toLowerCase()) || user.full_name.toLowerCase().includes(searchfield.toLowerCase())
    })
    if (users.isLoading) {
      return <CircleLoading />
    } else {
      return (
        <div>
          <div className="showInfoHead">
            <div className="showInfoHead-title">
              user management
            </div>
            <div className='showInfoHead-title showButtonHead'>
              <NavLink to={`${process.env.PUBLIC_URL}/AddUserPage`} className='dt-btn --iconOnly --bg-success'><i className="material-icons">add</i></NavLink>
            </div>
            <SearchBox searchChange={this.onSearchChange} />
          </div>
          <div className="showInfoContent">
            {
              (users.data).length !== 0
                ? (
                  <table className="dt-tableViewList --widthMax">
                    <thead>
                      <tr>
                        <th>Full Name</th>
                        <th>Username</th>
                        <th>Role</th>
                        <th className='fixWidth'>Active</th>
                        <th></th>
                      </tr>
                    </thead>
                    <TableTbody users={filterUser} />
                  </table>
                )
                : (
                  <div>No data</div>
                )
            }

          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  users: state.users
})

const mapDispatchToProps = dispatch => {
  return {
    loadUsers: () => {
      dispatch(usersAction.getAllUser())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(userManagePage)
